export enum PostType {
  EDITED_STORY = "63",
  PICTURE = "3",
  STORY = "62",
  VIDEO = "1",
}
